export const BG = '#080807';
export const TEXT = '#F5EEEA';
export const TEXT_2 = 'rgba(245,238,234,0.62)';
export const TEXT_3 = 'rgba(245,238,234,0.45)';
export const ACCENT = '#FF7A54';
export const ACCENT_2 = '#FF9273';
export const ACCENT_GRAD = 'linear-gradient(180deg, #FF9174, #F4653D)';
export const ON_ACCENT = '#170B06';
